export const dbPanels = {
  images: {
    subtitle: `ارفع صور كل وحدة ورتّبها وحدّد صورتها الرئيسية التي ستظهر في محرك الحجوزات.`,
  },

  amenities: {
    searchPlaceholder: `ابحث عن وسيلة راحة…`,
    selectedCount: `{count} وسيلة راحة محددة | {count} وسائل راحة محددة`,
    noResults: `لا نتائج لـ "{query}".`,
    // Fotos por comodidad: lo que el Agente IA le enseña al huésped.
    photos: {
      explain: `سيعرضها الوكيل على الضيف الذي يسأل عن وسيلة الراحة هذه.`,
      dropTitle: `اسحب الصور إلى هنا`,
      addPhotos: `إضافة صور`,
      dropHint: `JPG أو PNG أو WebP أو HEIC · حتى {mb} ميغابايت للصورة`,
      dropActive: `أفلت الصور لرفعها`,
      uploading: `جارٍ الرفع… {progress}%`,
      uploaded: `تمت إضافة {count} صورة | تمت إضافة {count} صور`,
      counter: `{count} صورة | {count} صور`,
      remaining: `يمكنك إضافة {count} صورة أخرى | يمكنك إضافة {count} صور أخرى`,
      full: `تم الوصول إلى الحد الأقصى وهو {max} صور`,
      tooMany: `لا تتجاوز {max} صور لكل وسيلة راحة.`,
      tooHeavy: `حجم «{name}» يزيد عن {mb} ميغابايت. صغّرها قبل الرفع.`,
      notImage: `«{name}» ليست صورة.`,
      uploadError: `تعذّر رفع الصور.`,
      removeAria: `إزالة هذه الصورة`,
      deleteTitle: `هل تريد إزالة هذه الصورة؟`,
      deleteBody: `لن يعرضها الوكيل بعد الآن عند السؤال عن «{amenity}». لا يمكن التراجع.`,
      deleteCancel: `إلغاء`,
      deleteConfirm: `إزالة الصورة`,
      deleted: `تمت إزالة الصورة`,
      deleteError: `تعذّر إزالة الصورة.`,
      // Orden: el agente solo manda las primeras, por eso se puede arrastrar.
      orderHint: `يعرض الوكيل أول {count} صور. اسحب من المقبض لتغيير الترتيب.`,
      dragTitle: `اسحب لإعادة الترتيب`,
      reordering: `جارٍ حفظ الترتيب…`,
      orderSaved: `تم حفظ الترتيب`,
      orderError: `تعذّر حفظ الترتيب.`,
      willSend: `سيرسل الوكيل هذه الصورة`,
      wontSend: `لن يصل الوكيل إلى هذه الصورة`,
      someFailed: `تعذّرت معالجة: {names}`,
    },
  },

  occupancy: {
    question: `ما التعديل الذي تريد تطبيقه؟`,
    questionRoom: `ما التعديل الذي تريد تطبيقه على هذه الغرفة؟`,
    modeNone: `لا شيء`,
    modeReduction: `تخفيض`,
    modeSurcharge: `زيادة`,
    baseOccupancy: `الإشغال الأساسي`,
    baseHint: `ضيوف (السعر المعتاد)`,
    thOccupancy: `الإشغال`,
    thRule: `القاعدة`,
    thValue: `القيمة`,
    thActive: `مُفعّل`,
    guestsCount: `{count} ضيف | {count} ضيوف`,
    ruleReductionPct: `تخفيض ٪`,
    ruleReductionFixed: `تخفيض {currency}`,
    reductionInfo: `لعدد ضيوف أقل من الإشغال الأساسي، يُطبَّق هذا التخفيض على سعر الإقامة.`,
    priceIncludes: `يشمل السعر`,
    guestsCapacity: `ضيف (سعة الغرفة) | ضيوف (سعة الغرفة)`,
    maxExtraGuests: `الحد الأقصى للضيوف الإضافيين`,
    chargePerExtraGuest: `رسوم لكل ضيف إضافي`,
    chargeFixed: `{currency} ثابت`,
    perNight: `لكل ليلة`,
    surchargeInfo: `يدفع كل ضيف يتجاوز السعة المشمولة هذه الرسوم لكل ليلة.`,
    noneRoom: `لا يوجد لهذه الغرفة تعديل حسب الإشغال: السعر نفسه لأي عدد من الضيوف (ضمن السعة).`,
    noneBooking: `لا يوجد لهذا الحجز تعديل حسب الإشغال: السعر نفسه لأي عدد من الضيوف (ضمن السعة).`,
  },

  share: {
    title: `مشاركة (فندق)`,
    desc: `هذا الرابط خاص بهذا الفندق. شاركه عبر واتساب أو افتحه كزائر.`,
    linkLabel: `رابط حجوزات الفندق`,
    linkHint: `استخدمه في نبذتك أو حملاتك أو رسائلك التلقائية.`,
    viewAsVisitor: `عرض كزائر`,
    tip: `نصيحة: يمكنك إرسال هذا الرابط مع رسالة تأكيد الحجز.`,
    noLinkCopy: `لا يوجد رابط لنسخه.`,
    copied: `تم نسخ الرابط.`,
    copyError: `تعذّر نسخ الرابط.`,
    noLinkShare: `لا يوجد رابط لمشاركته.`,
    whatsappMsg: `مرحبًا 👋 أشاركك رابط الحجز في هذا الفندق: {link}`,
    noLinkOpen: `لا يوجد رابط لفتحه.`,
  },

  unitServices: {
    title: `التجهيزات ووسائل الراحة`,
    subPrefix: `وسائل الراحة لـ`,
    thisRoom: `هذه الغرفة`,
    subInfo: `لكل نوع غرفة وسائله الخاصة؛ ويستخدم الحجز المباشر والوكيل الذكي وسائل الغرفة المخصصة للضيف.`,
    loading: `جارٍ تحميل وسائل الراحة…`,
    loadError: `تعذّر تحميل وسائل الراحة لهذه الغرفة.`,
    retry: `إعادة المحاولة`,
    saving: `جارٍ الحفظ…`,
    saved: `تم الحفظ`,
    autosaveHint: `يُحفظ تلقائيًا عند التحديد أو إلغاء التحديد.`,
  },

  welcome: {
    tag: `محرك الحجوزات المباشرة`,
    titleA: `استقبل حجوزات`,
    titleHighlight: `بدون عمولات`,
    sub: `محرك حجوزات خاص بك لكل إقامة: تشارك رابطًا، فيحجز الضيف ويدفع مباشرةً. بلا وسطاء ولا عمولات لمنصات الحجز.`,
    howItWorks: `كيف يعمل`,
    benefits: `المزايا`,
    step1Title: `شارك رابطك`,
    step1Text: `لكل إقامة رابطها الخاص. انشره على موقعك أو شبكاتك أو واتساب؛ ويرسله الوكيل الذكي أيضًا إلى العملاء المحتملين.`,
    step2Title: `الضيف يحجز`,
    step2Text: `يختار التواريخ ويدفع في محركك. يدخل الحجز مباشرةً إلى تقويمك بلا عمولات لمنصات الحجز.`,
    step3Title: `تتقاضى مباشرةً`,
    step3Text: `تستلم الدفع بلا وسطاء وتضيف العروض والرسوم والخدمات الإضافية إلى كل إقامة.`,
    ctaStart: `ابدأ الإعداد`,
    ctaPromotions: `عرض العروض العامة`,
    perk1Title: `صفر عمولات لمنصات الحجز`,
    perk1Text: `تحتفظ بـ100% من كل حجز مباشر.`,
    perk2Title: `دفع وتأكيد فوري`,
    perk2Text: `يدفع الضيف ويتأكد الحجز تلقائيًا.`,
    perk3Title: `عروض ورسوم إضافية`,
    perk3Text: `خصومات حسب الإقامة وخدمات ورسوم خاصة بك.`,
    perk4Title: `رابط واحد لكل إقامة`,
    perk4Text: `لكل إعلان محركه ومدى توفره الخاص.`,
  },

  unitsList: {
    title: `الوحدات المتاحة`,
    subtitle: `فعّل الوحدات التي تريد عرضها في محرك الحجوزات.`,
    loading: `جارٍ التحميل…`,
    sectionUnits: `الوحدات`,
    colUnit: `الوحدة`,
    colCap: `السعة`,
    colActive: `مُفعّلة`,
    noUnits: `لا توجد وحدات مُعدّة.`,
    active: `مُفعّلة`,
    inactive: `غير مُفعّلة`,
    noticePrefix: `فعّل الحجوزات المباشرة من`,
    noticeGlobalConfig: `الإعدادات العامة`,
    noticeSuffix: `لإدارة الوحدات.`,
    sectionLink: `رابط الشقة الفردي`,
    linkCardTitle: `رابط مُصفّى لهذه الشقة`,
    linkCardDesc: `يفتح محرك الحجوزات العام نفسه، لكنه يعرض هذه الشقة مباشرةً.`,
    viewAsVisitor: `عرض كزائر`,
    unitUpdated: `تم تحديث الوحدة.`,
    updateError: `تعذّر التحديث.`,
    noLinkCopy: `لا يوجد رابط لنسخه.`,
    linkCopied: `تم نسخ الرابط.`,
    copyError: `تعذّر نسخ الرابط.`,
    noLinkOpen: `لا يوجد رابط لفتحه.`,
  },

  commonAreaImages: {
    intro: `صور عامة (المدخل، المسبح، الاستقبال، الحديقة…) يراها العميل كواجهة عند فتح المحرك، إضافةً إلى معرض كل وحدة.`,
    imagesCount: `{count} صورة | {count} صور`,
    reorderHint: `اسحب لإعادة الترتيب · الرئيسية هي الواجهة`,
    reordering: `جارٍ الترتيب…`,
    dragTitle: `اسحب`,
    coverBadge: `الواجهة`,
    empty: `لم تُضِف بعد صورًا للمناطق المشتركة. ارفعها بالأعلى لإنشاء واجهة الإعلان.`,
    loadError: `تعذّر تحميل صور المناطق المشتركة.`,
    uploadSuccess: `تم رفع الصور بنجاح.`,
    uploadError: `تعذّر رفع الصور.`,
    orderUpdated: `تم تحديث الترتيب.`,
    orderError: `تعذّر تحديث الترتيب.`,
    deleteConfirmMsg: `حذف صورة المناطق المشتركة هذه؟`,
    deleteConfirmHeader: `حذف الصورة`,
    deleteAccept: `حذف`,
    deleteReject: `إلغاء`,
    imageDeleted: `تم حذف الصورة.`,
    deleteError: `تعذّر حذف الصورة.`,
    coverUpdated: `تم تحديث الواجهة.`,
    coverError: `تعذّر تعيين الواجهة.`,
    invalidFiles: `ملفات غير صالحة: {message}\n{details}`,
  },
};
